import styles from './ResetPwdPage.module.less'
import { useSearchParams } from 'react-router-dom'
import PreperResetPwdCard from './components/PreperResetPwdCard/PreperResetPwdCard'
import ResetPwdCard from './components/ResetPwdCard/ResetPwdCard'

function ResetPwdPage() {
  const [searchParams] = useSearchParams()
  const code = searchParams.get('c')
  return (
    <div className={styles.resetPwdPage} data-testid='reset-pwd-page'>
      <div className={styles.resetPwdPageContent}>
        {code ? <ResetPwdCard code={code} /> : <PreperResetPwdCard />}
      </div>
    </div>
  )
}

export default ResetPwdPage
